module.exports = __webpack_public_path__ + "static/media/HIELO PROGRESO.43027332.png";